import authService from "./services/authService";

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

const updateHeaderInterceptor = (axiosInstance) => {
    axiosInstance.interceptors.request.use((config) => {
        // config.headers["X-CSRF-TOKEN"] = getCookie('CSRF-TOKEN');
        const token = authService.getToken();
        if (token) {
            config.headers.Authorization = token;
        }
        return config;
    },(error) => {

    });
};
export default updateHeaderInterceptor;